import { render, staticRenderFns } from "./PlanUsersEmail.vue?vue&type=template&id=ddeaaa34&scoped=true"
import script from "./PlanUsersEmail.vue?vue&type=script&lang=js"
export * from "./PlanUsersEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddeaaa34",
  null
  
)

export default component.exports